export enum LoginFields {
	email = 'email',
	password = 'password',
}

export type SocialLoginMethod = 'google' | 'apple' | 'facebook';
